export const statistics = {
  statistics: {
    general: {
      notRunning: 'Not running',
    },
    button: {
      downloadCSV: 'DOWNLOAD CSV',
      openDetailed: 'DETAILED STATISTICS',
      resetStats: 'RESET',
    },
    reset: {
      success: "Stream's statistics have been reset",
      error: "Failed to reset stream's statistics",
    },
    header: {
      detailedStatistics: 'DETAILED STATISTICS',
      downloadCSVButtonTitle: 'DOWNLOAD CSV',
      resetButtonTitle: 'RESET',
      srtStatistics: 'SRT STATISTICS',
      statistics: 'STATISTICS',
    },
    options: {
      refreshInterval: 'Refresh Every',
    },
    units: {
      sec: 'sec',
      ms: 'ms',
      smallerThan1Ms: '< 1 ms',
    },
    path1: 'Path 1',
    path2: 'Path 2',
    pathSelection: 'Show Paths',
    pathSelectionAll: 'All',
    pathSelectionNone: 'None',
    stream: {
      none: 'None',
      title: 'Stream {{id}} Statistics',
      srtVersionPrefix: 'version',
      goBack: 'Back to Streams',
      section: {
        stream: 'STREAM',
        statistics: 'STATISTICS',
        errors: 'ERRORS',
        srt: 'SRT',
        fec: 'Pro-MPEG FEC',
      },
      rows: {
        // STREAM
        id: 'ID',
        // STATISTICS
        bitrate: 'Bitrate',
        connections: 'Connections',
        destAddress: 'Resolved Address',
        duplicate: 'Duplicate',
        encapsulation: 'Encapsulation',
        lastRxError: '',
        lastTxError: '',
        output: 'Output',
        packetRate: 'Packet Rate',
        pcrPid: 'PCR PID',
        programNumber: 'Program Number',
        rtcp: '',
        RTCPReporters: '',
        rtmpLastError: '',
        rxInvalidRTCPBytes: '',
        rxInvalidRTCPPackets: '',
        rxOKRTCPBytes: '',
        rxOKRTCPPackets: '',
        sentBytes: 'Sent Bytes',
        sentPackets: 'Sent Packets',
        sourceAddress: '',
        sourceBitrate: 'Bitrate',
        sourceCompression: 'Compression',
        sourceDts: 'DTS',
        sourcePort: 'Source Port',
        sourceProgramId: 'Program ID',
        sourcePts: 'PTS',
        sourceReceivedBytes: 'Received Bytes',
        sourceReceivedPackets: 'Received Packets',
        streamSummary: 'Stream Summary',
        txFailedRTCPPackets: '',
        txOKRTCPBytes: '',
        unsentBytes: 'Unsent Bytes',
        unsentPackets: 'Unsent Packets',
        // ERRORS
        corruptedFrames: 'Corrupted Frames',
        restarts: 'Resumed Stream Flags',
        // SRT
        authentication: 'Authentication',
        buffer: 'Local Buffer Level',
        detectedRedundancyMode: 'Redundancy',
        droppedBytes: 'Dropped Bytes',
        encryption: 'Encryption',
        encryptionMode: 'Encryption',
        keyLength: 'Key Length',
        lastError: 'Last Error',
        latency: 'Latency',
        localEndpoint: 'Local Endpoint',
        localPort: 'Local Port',
        lostPackets: 'Lost Packets',
        maxBandwidth: 'Max Bandwidth',
        mss: 'MTU' /* sic */,
        occurred: 'Occured',
        path: '',
        pathMaxBandwidth: 'Path Max Bandwidth',
        peerDecryption: 'Peer Decryption',
        peerDecryptionActive: 'Active',
        peerDecryptionInactive: 'Inactive ({{reason}})',
        peerEndpoint: 'Peer Endpoint',
        peerVersion: 'Peer Version',
        reconnections: 'Reconnections',
        recovered: 'Resent',
        recvACK: 'Received ACKs',
        recvNAK: 'Received NAKs',
        rejectedLastTime: 'Last Rejected',
        rejectedReason: 'Reason',
        rejectedStreamId: 'StreamID',
        resentBytes: 'Resent Bytes',
        resentPackets: 'Resent Packets',
        rtt: 'RTT',
        skippedPackets: 'Skipped Packets',
        uptime: 'Uptime',
        lastReset: 'Last Statistics Reset',
        // FEC
        blockAligned: 'Block Aligned',
        droppedPackets: 'Dropped Packets',
        level: 'Level',
        numberOfColumns: 'Number of Columns',
        numberOfRows: 'Number of Rows',
        recoveredPackets: 'Recovered Packets',
      },
    },
    videoEncoder: {
      section: {
        main: 'Statistics',
      },
      rows: {},
    },
    chart: {
      bandwidthTitle: 'BANDWIDTH USED (kbps)',
      bandwidthTitleFull: 'Bandwidth Used (kbps)',
      delayTitle: 'DELAY (ms)',
      delayTitleFull: 'Delay (ms)',
      timescale: {
        optionsName: {
          last5min: '5 mins',
          last60min: '60 mins',
          last24hours: '24 hrs',
        },
      },

      csvValues: {
        SendBufs: 'Send Buffer',
        SendRate: 'Send Rate',
        ReSnRate: 'Retransmit Rate',
        AvailBw: 'Link BW',
        PdDelay: 'Latency',
        RTT: 'Round Trip',
        SendBufs_Path2: 'Send Buffer',
        SendRate_Path2: 'Send Rate',
        ReSnRate_Path2: 'Retransmit Rate',
        AvailBw_Path2: 'Link BW',
        PdDelay_Path2: 'Latency',
        RTT_Path2: 'Round Trip',
      },
    },
    thumbnailTitle: 'OUTPUT REVIEW',
  },
};
